import { render, staticRenderFns } from "./LobbyActions.vue?vue&type=template&id=1636a23c&scoped=true&"
import script from "./LobbyActions.vue?vue&type=script&lang=js&"
export * from "./LobbyActions.vue?vue&type=script&lang=js&"
import style0 from "./LobbyActions.vue?vue&type=style&index=0&id=1636a23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636a23c",
  null
  
)

export default component.exports